import React, { useState } from 'react';
import "./PostBox.css";
import { Avatar } from "@material-ui/core";
import PhotoAlbumRoundedIcon from "@material-ui/icons/PhotoAlbumRounded";
import firebase from "firebase";
import { storage, db } from "../firebase";
import { Link } from "react-router-dom";
import CloseIcon from "@material-ui/icons/Close";
import VideocamIcon from "@material-ui/icons/Videocam";

function PostBox() {
    const user = firebase.auth().currentUser;
    const [image, setImage] = useState(null);
    const [caption, setCaption] = useState("");
    const [progress, setProgress] = useState(0);
    const [imageURL, setImageURL] = useState("");
    const [video, setVideo] = useState(null);
    const [videoURL, setVideoURL] = useState("");

    const handleChange = (e) => {
        if (e.target.files[0]) {
            setImage(e.target.files[0]);
            setImageURL(URL.createObjectURL(e.target.files[0]))
        }
    }

    const handleVideoChange = (e) => {
        if (e.target.files[0]) {
            setVideo(e.target.files[0]);
            setVideoURL(URL.createObjectURL(e.target.files[0]))
        }
    }

    const removeImage = () => {
        setImage(null);
        setImageURL("");
    }

    const openFileDialogBox = () => {
        document.getElementsByClassName("postBox__fileUploader")[0].click();
    }

    const openVideoDialogBox = () => {
        document.getElementsByClassName("postBox__fileVideoUploader")[0].click();
    }

    const handleUpload = (e) => {
        if(caption === "" && image === null) {
            alert("Please type something or attach an image to make a post")
        } else if (image) {
            const uploadTask = storage.ref(`images/${image.name}`).put(image);
        
        uploadTask.on(
            "state_changed",
            (snapshot) => {
                // progress function...
                const progress = Math.round(
                    (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                );
                setProgress(progress);
            },
            (error) => {
                // Error function...
                console.log(error);
                alert(error.message);
            },
            () => {
                // complete function...
                storage
                .ref("images")
                .child(image.name)
                .getDownloadURL()
                .then(url => {
                    // post image inside db
                    db.collection("posts").add({
                        timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                        caption: caption,
                        imageUrl: url,
                        username: user?.displayName,
                        photoURL: user?.photoURL,
                        likes: 0,
                        uid: user?.uid
                    });

                    setProgress(0);
                    setCaption("");
                    setImage(null);
                   });
            }
        )
        } else {
            db.collection("posts").add({
                        timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                        caption: caption,
                        username: user?.displayName,
                        photoURL: user?.photoURL,
                        likes: 0,
                        uid: user?.uid
            })
            setCaption("");
        }
    }

    return (
        <div className="postBox">
            <div className="postBox__upside">
                <Link className="link" to={`/${user?.displayName}/${user?.uid}`}><Avatar src={user?.photoURL} /></Link>
                <textarea value={caption} onChange={(e) => setCaption(e.target.value)} placeholder={`Have something for the world, ${user?.displayName}?`} />
            </div>
            {
                image && (
                    <div className="postBox__postImagePreview">
                        <CloseIcon onClick={removeImage}/>
                        <img src={imageURL} alt="" />
                    </div>
                )
            }
            {
                video && (
                    <div className="postBox__postVideoPreview">
                        <CloseIcon onClick={removeImage}/>
                        <video  controls>
                            <source src={videoURL}></source>
                        </video>
                </div>
                )
            }
            <div className="postBox__downside">
                <input onChange={handleChange} className="postBox__fileUploader" type="file" accept="image/*" />
                <input onChange={handleVideoChange} className="postBox__fileVideoUploader" type="file" accept="video/*"/>
                <div className="postBox_downside_leftSide">
                    <div className="postBox_downside_leftSide__options" onClick={openFileDialogBox}>
                        <PhotoAlbumRoundedIcon style={{ color: "green" }} />
                    </div>
                    <div className="postBox_downside_leftSide__options" onClick={openVideoDialogBox}>
                        <VideocamIcon style={{ color: "red" }}/>
                    </div>
                </div>
                <button type="submit" onClick={handleUpload} className="postBox__postButton">Post</button>
            </div>
            <progress value={progress} max="100" className="postBox__progress" />
        </div>
    )
}

export default PostBox;